export const OutlookAuthConfig = {
    clientId: 'a05ac919-2f82-4d99-8efd-d51ce1d267ca',
    scopes: [
        'user.read',
        'calendars.readwrite'
    ]
}
